import React, { useState } from "react";
import { Dropdown } from "../../assets";
import { TransitionGroup, CSSTransition } from "react-transition-group";

const times = ["00:00:00", "00:30:00", "01:00:00", "01:30:00", "02:00:00", "02:30:00", "03:00:00", "03:30:00", "04:00:00", "04:30:00", "05:00:00", "05:30:00", "06:00:00", "06:30:00", "07:00:00", "07:30:00", "08:00:00", "08:30:00", "09:00:00", "09:30:00", "10:00:00", "10:30:00", "11:00:00", "11:30:00", "12:00:00", "12:30:00", "13:00:00", "13:30:00", "14:00:00", "14:30:00", "15:00:00", "15:30:00", "16:00:00", "16:30:00", "17:00:00", "17:30:00", "18:00:00", "18:30:00", "19:00:00", "19:30:00", "20:00:00", "20:30:00", "21:00:00", "21:30:00", "22:00:00", "22:30:00", "23:00:00", "23:30:00"];

const days = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];

function serializeSlot(slot) {
	return `${slot.day}_${slot.from}_${slot.to}`;
}

export default function OpeningTimes({ values = [], change }) {

	// Find the last used day for better UX.
	let lastValue = values[values.length - 1];
	let startingDay;
	if (!lastValue || lastValue.day === "SUN") {
		startingDay = "MON";
	} else {
		startingDay = days[days.indexOf(lastValue.day) + 1];
	}

	const [entry, setEntry] = useState({
		day: startingDay,
		from: "09:00:00",
		to: "17:00:00"
	});

	function changeEntry(name, val) {
		setEntry({
			...entry,
			[name]: val
		})
	}

	function formatHour(hour) {
		// Changes the format from HH:MM:SS to HH:MM
		hour = hour.split(":");
		return `${hour[0]}:${hour[1]}`
	}

	return <div className="openingTimes">
		<TransitionGroup className="existing">
			{values
				.sort((a, b) => {
					return days.indexOf(a.day) - days.indexOf(b.day)
				})
				.map(v => (
					<CSSTransition
						key={serializeSlot(v)}
						timeout={300}
						classNames="list-anim"
					>
						<div className="time-item" key={serializeSlot(v)}>
							<span style={{ display: "inline-block", width: "70px" }}>{`${v.day}:`}</span>
							<span>{`${formatHour(v.from)} - ${formatHour(v.to)}`}</span>
							<div
								className="remove"
								onClick={() => {
									change(values.filter(val => serializeSlot(val) !== serializeSlot(v)));
								}}
							>x</div>
						</div>
					</CSSTransition>
				))}
		</TransitionGroup>
		{Boolean(values.length) && <br />}
		<div className="flexy" style={{ marginTop: 10 }}>
			<div className="dropdownLabel">Day</div>
			<div className="dropdownLabel">From</div>
			<div className="dropdownLabel">To</div>
			<div style={{ flex: 0.5, padding: 5 }}></div>
		</div>
		<div className="new flexy" style={{ marginTop: 5 }}>
			<Dropdown
				value={entry.day}
				placeholder="Day"
				options={days.map(d => ({ name: d, value: d }))}
				onSelect={val => changeEntry("day", val)}
			/>
			<Dropdown
				value={entry.from}
				placeholder="From"
				onSelect={val => changeEntry("from", val)}
				options={times
					.map(t => ({ name: t.replace(/:\d\d$/, ""), value: t }))
				}
			/>
			<Dropdown
				value={entry.to}
				placeholder="To"
				onSelect={val => changeEntry("to", val)}
				options={times
					.filter(t => (
						Number(t.replace(/:/g, "")) > Number(entry.from.replace(/:/g, ""))
					))
					.map(t => ({ name: t.replace(/:\d\d$/, ""), value: t }))
				}
			/>
			<button
				style={{ flex: 0.5, padding: "5px 5px 8px 5px", fontSize: "1.2rem" }}
				disabled={!(
					entry.day &&
					entry.from &&
					entry.to &&
					!values.find(slot => serializeSlot(slot) === serializeSlot(entry))
				)}
				className="add"
				onClick={() => {
					change([...values, { ...entry }]);
					setEntry({
						...entry,
						day: days[days.indexOf(entry.day) + 1]
					});
				}}
			>Add</button>
		</div>
	</div>

}